const TrackingReadyEventName = 'trackingReady';

function onTrackingReady(callback) {
  if (typeof window === 'undefined') return;

  const listener = () => {
    if (window.tracking) {
      callback(window.tracking);
    }

    window.removeEventListener(TrackingReadyEventName, listener);
  };

  if (window && window.tracking && window.tracking.track) {
    callback(window.tracking);
  } else {
    window.addEventListener(TrackingReadyEventName, listener);
  }
}

function track(event, properties) {
  onTrackingReady(tracking => {
    tracking.track(event, properties);
  });
}

function getTiming(eventName) {
  if (typeof window === 'undefined' || !window.performance || !window.performance.mark) return 0;
  const mark = window.performance.mark(eventName);

  if (mark) {
    return mark.startTime;
  }

  const entries = window.performance.getEntriesByName(eventName);

  if (entries && entries.length > 0) {
    return entries[0].startTime;
  }

  return 0;
}

const UserInteractionEventName = 'Interaction Timed';
function trackUserInteractionWithTiming(props) {
  if (!props.eventName) {
    throw new Error('Missing eventName');
  }

  try {
    track(UserInteractionEventName, {
      eventName: props.eventName,
      timing: props.timing,
      eventDetail: props.eventDetail
    });
  } catch (error) {
    console.error('Something went wrong in @vp/track-user-interaction -> trackUserInteractionWithTiming', error);
  }
}
function trackUserInteraction(props) {
  if (!props.eventName) {
    throw new Error('Missing eventName');
  }

  try {
    const timing = getTiming(props.eventName);
    trackUserInteractionWithTiming({
      eventName: props.eventName,
      timing: timing
    });
  } catch (error) {
    console.error('Something went wrong in @vp/track-user-interaction -> trackUserInteraction', error);
  }
}

export { trackUserInteraction, trackUserInteractionWithTiming };
//# sourceMappingURL=track-user-interaction.esm.js.map
